import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "glogrid_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const requestOtp = async (email) => {
  const res = await apiClient.post("/auth/request-otp", { email });
  return res.data;
};

export const verifyOtp = async (email, code) => {
  const res = await apiClient.post("/auth/verify-otp", { email, code });
  return res.data;
};

export const getMe = async () => {
  const res = await apiClient.get("/auth/me");
  return res.data;
};

export const getNda = async () => {
  const res = await apiClient.get("/legal/nda");
  return res.data;
};

export const acceptNda = async () => {
  const res = await apiClient.post("/auth/accept-nda");
  return res.data;
};

const withToken = (url) => {
  const t = getToken();
  if (!t) return url;
  return `${url}${url.includes("?") ? "&" : "?"}token=${encodeURIComponent(t)}`;
};

export const adminStats = async () => {
  const res = await apiClient.get("/admin/stats");
  return res.data;
};

export const adminReset = async (email) => {
  const res = await apiClient.post(`/admin/users/${encodeURIComponent(email)}/reset`);
  return res.data;
};

export const adminSetUnlimited = async (email, value) => {
  const res = await apiClient.post(`/admin/users/${encodeURIComponent(email)}/unlimited`, { value });
  return res.data;
};

export const adminDeleteUser = async (email) => {
  const res = await apiClient.delete(`/admin/users/${encodeURIComponent(email)}`);
  return res.data;
};

export const analyzePart = async (formData) => {
  const res = await apiClient.post("/analyze", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 180000,
  });
  return res.data;
};

export const fetchHistory = async () => {
  const res = await apiClient.get("/analyses");
  return res.data;
};

export const fetchAnalysis = async (id) => {
  const res = await apiClient.get(`/analyses/${id}`);
  return res.data;
};

export const deleteAnalysis = async (id) => {
  const res = await apiClient.delete(`/analyses/${id}`);
  return res.data;
};

export const sendRfq = async (id, payload) => {
  const res = await apiClient.post(`/analyses/${id}/rfq`, payload);
  return res.data;
};

export const recostRegion = async (id, pincode) => {
  const res = await apiClient.post(`/analyses/${id}/recost`, { pincode });
  return res.data;
};

export const costingXlsxUrl = (id) => withToken(`${API}/analyses/${id}/costing.xlsx`);

export const reportPdfUrl = (id, client = "") =>
  withToken(`${API}/analyses/${id}/report.pdf${client ? `?client=${encodeURIComponent(client)}` : ""}`);

export const compareXlsxUrl = (ids) => withToken(`${API}/compare.xlsx?ids=${encodeURIComponent(ids)}`);

export const setRetention = async (days) => {
  const res = await apiClient.post("/auth/retention", { days });
  return res.data;
};

export const listRates = async () => {
  const res = await apiClient.get("/rates");
  return res.data;
};

export const createRate = async (payload) => {
  const res = await apiClient.post("/rates", payload);
  return res.data;
};

export const deleteRate = async (id) => {
  const res = await apiClient.delete(`/rates/${id}`);
  return res.data;
};

export const fetchCompare = async (ids) => {
  const res = await apiClient.get(`/compare`, { params: { ids } });
  return res.data;
};

export const inr = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
};
